import { EstimateForm } from "../components/EstimateForm";
import { useSite } from "../context/SiteContext";
import { PageHero } from "./AboutPage";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

export default function EstimatePage() {
  const { L } = useSite();
  return (
    <main data-testid="estimate-page">
      <Seo title={PAGE_SEO.estimate.title} description={PAGE_SEO.estimate.description} path="/estimate" />
      <PageHero overline={L.estimatePage.overline} title={L.estimatePage.title}
        subtitle={L.estimatePage.subtitle} />
      <section className="py-20 bg-[#F8FAFC]">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <EstimateForm />
        </div>
      </section>
    </main>
  );
}
